// Audit S1 (2026-10-16): <img>/<a> for /api/uploads/... URLs that may be
// sensitive. Resolves a short-TTL signed URL first (public classes such as
// avatars/condos pass through unchanged, so screens keep working).
import { useEffect, useState } from 'react';
import { resolveUploadUrl } from '../services/uploads';

type Props = { src: string | null | undefined; alt: string; className?: string };

export default function AuthedUploadImage({ src, alt, className }: Props) {
  const [resolved, setResolved] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    setResolved(null);
    if (!src) return;
    resolveUploadUrl(src)
      .then((u) => { if (alive) setResolved(u); })
      .catch(() => { if (alive) setResolved(null); });
    return () => { alive = false; };
  }, [src]);
  if (!resolved) return null;
  return <img src={resolved} alt={alt} className={className} />;
}

// Anchor variant: opens the resolved signed URL in a new tab and shows the
// image thumbnail once resolved.
export function AuthedUploadLink({ src, alt, imgClassName, className }: { src: string | null | undefined; alt: string; imgClassName?: string; className?: string }) {
  const [resolved, setResolved] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    setResolved(null);
    if (!src) return;
    resolveUploadUrl(src)
      .then((u) => { if (alive) setResolved(u); })
      .catch(() => { if (alive) setResolved(null); });
    return () => { alive = false; };
  }, [src]);
  if (!resolved) return null;
  return (
    <a href={resolved} target="_blank" rel="noreferrer" className={className}>
      <img src={resolved} alt={alt} className={imgClassName} />
    </a>
  );
}
